import { pathgen } from 'object-path-generator';
export const HelpMeWriteTextFieldTestIds = pathgen('HelpMeWriteTextFieldTestIds');
export var PresetType = /*#__PURE__*/ function(PresetType) {
    PresetType["Formalize"] = "formalize";
    PresetType["Polish"] = "polish";
    PresetType["Elaborate"] = "elaborate";
    PresetType["Shorten"] = "shorten";
    return PresetType;
}({});
export const presetButtonTestId = (presetValue)=>"HelpMeWriteTextFieldTestIds.".concat(presetValue);
